import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getuserdata, encryptId, formatUrlString, getroles, loginapi } from "../../../services/apiService";
import { useAuth } from "../../../context/AuthContext";
import { toast } from 'react-toastify';
import bannerimglocal from "../../../assets/images/benner_1.jpg";
import userimglocal from "../../../assets/images/9334243.jpg";
import ImageShow from "../../../Uitiles/ImageShow";
import SidebarController from "../../../controllers/SidebarController";
import "../../../assets/styles/submenu-styles.css";

const SiderBar = ({ showsiderbar, handleClick, isMobile, userType = "" }) => {
  const [userdata, setUserData] = useState({});
  const [displayName, setDisplayName] = useState("");
  const [menuList, setMenuList] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [userPermissions, setUserPermissions] = useState([]);
  const { logout, login } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    try {
      // Use the proper logout function from AuthContext
      logout();
    } catch (error) {
      console.error("Error during logout:", error);
      // Fallback to manual logout
      localStorage.clear();
      sessionStorage.clear();
      navigate("/", { replace: true });
      window.location.reload();
    }
  };

  const handleLoginReturn = async () => {
    console.log('Attempting return to original dashboard...');
    const localuser = localStorage.getItem("presentuser");
    const redirect_url = localStorage.getItem("redirect_url_admin") || "/admin/dashboard";

    if (!localuser) {
      toast.error("No original session found.");
      return;
    }

    try {
      const parsedData = JSON.parse(localuser);
      const loginResponse = await loginapi(parsedData.email, parsedData.pass, true);

      const user = loginResponse.data[0];

      if (user) {
        if (user.status === "2") {
          toast.error("Your account has been deleted. Please contact support.");
          return;
        }

        const userData = {
          id: user.id,
          email: user.email,
          user_type: user.user_type || "user",
          display_name: user.display_name || user.email
        };

        const loginSuccess = await login(userData);

        if (loginSuccess) {
          toast.success("Returned to original session!", { autoClose: 2000 });
          navigate(redirect_url);
        } else {
          toast.error("Failed to restore session.");
        }
      } else {
        toast.error("Original user not found.");
      }
    } catch (error) {
      console.error("Error during return session:", error);
      toast.error("An error occurred while returning to dashboard.");
    }
  }

  const toggleSubmenu = (path, event) => {
    event.preventDefault();
    event.stopPropagation();

    const updatedMenuList = [...menuList];
    SidebarController.toggleSubmenu(updatedMenuList, path);

    setMenuList(updatedMenuList);
  };

  useEffect(() => {
    getUserProfile();

  }, []);

  useEffect(() => {
    if (userdata.user_type) {
      buildMenu();
    }
  }, [userType, userRole, userdata]);


  const getUserProfile = async () => {
    const data = await getuserdata("full");
    console.log("getUserProfile data :", data);
    setDisplayName(data.display_name);
    setUserRole(data.user_type);
    console.log("userRole", userRole);
    setUserPermissions(data.permissions || []);
    setUserData(data);
  };

  const buildMenu = async () => {
    const getpermissions = await getroles(userdata.role);
    console.log("getpermissions buildMenu :", getpermissions);
    if (getpermissions.data.length > 0) {
      console.log("getpermissions buildMenu :", getpermissions.data[0].permissions);
      setUserPermissions(getpermissions.data[0].permissions || []);
      const menu = SidebarController.buildMenu(userdata, getpermissions.data[0].permissions, displayName);
      setMenuList(menu);
    } else {
      setUserPermissions([]);
      const menu = SidebarController.buildMenu(userdata, userPermissions, displayName);
      setMenuList(menu);
    }
  };

  const renderMenuItem = (menu, level = 0, isSubmenu = false) => {
    return menu.map((menuItem, index) => (
      <React.Fragment key={`${menuItem.key || index}-${level}`}>
        <li
          className={`${SidebarController.isActivePath(window.location.pathname, menuItem.path) ? "dc-active" : ""} ${menuItem.hasChildren ? "has-submenu" : ""} ${isSubmenu ? "submenu-item" : ""
            } ${menuItem.expanded ? "submenu-expanded dc-active" : ""} ${SidebarController.isActiveSubmenu(window.location.pathname, menuItem.path) ? "submenu-expanded" : ""}`}
        >
          {/* Menu Item (Link / Action / External / Parent) */}
          {menuItem.hasChildren ? (
            <a
              href="#"
              onClick={(e) => toggleSubmenu(menuItem.path, e)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {menuItem.icon_type === "image" ? (
                  <img src={menuItem.icon} alt="" style={{ width: "20px", height: "20px", marginRight: showsiderbar ? "0" : "10px", objectFit: "contain" }} />
                ) : (
                  <i className={menuItem.icon}></i>
                )}
                {!showsiderbar && <span>{menuItem.label}</span>}
              </div>
              {!showsiderbar && menuItem.hasChildren && (
                <i
                  className={`fas fa-chevron-${menuItem.expanded ? "down" : "right"}`}
                  style={{ fontSize: "12px", transition: "transform 0.3s ease", }}
                ></i>
              )}
            </a>
          ) : menuItem.type === "external" || menuItem.external ? (
            <a
              href={menuItem.url || menuItem.path}
              target={menuItem.target || "_blank"}
              rel="noopener noreferrer"
              style={{ display: "flex", alignItems: "center" }}
            >
              {menuItem.icon_type === "image" ? (
                <img src={menuItem.icon} alt="" style={{ width: "20px", height: "20px", marginRight: showsiderbar ? "0" : "10px", objectFit: "contain" }} />
              ) : (
                <i className={menuItem.icon} style={{ marginRight: "10px" }}></i>
              )}
              {!showsiderbar && <span>{menuItem.label}</span>}
            </a>
          ) : menuItem.type === "action" || menuItem.action === "logout" || menuItem.action === "login_return" ? (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                if (menuItem.action === "logout") handleLogout();
                if (menuItem.action === "login_return") handleLoginReturn();
              }}
              style={{ display: "flex", alignItems: "center" }}
            >
              {menuItem.icon_type === "image" ? (
                <img src={menuItem.icon} alt="" style={{ width: "20px", height: "20px", marginRight: showsiderbar ? "0" : "10px", objectFit: "contain" }} />
              ) : (
                <i className={menuItem.icon}></i>
              )}
              {!showsiderbar && <span>{menuItem.label}</span>}
            </a>
          ) : (
            <Link
              to={menuItem.url || menuItem.path}
              onClick={(e) => {
                if (menuItem.action === "logout") {
                  e.preventDefault();
                  handleLogout();
                }
                if (menuItem.action === "login_return") {
                  e.preventDefault();
                  handleLoginReturn();
                }
              }}
              style={{ display: "flex", alignItems: "center" }}
            >
              {menuItem.icon_type === "image" ? (
                <img src={menuItem.icon} alt="" style={{ width: "20px", height: "20px", marginRight: showsiderbar ? "0" : "10px", objectFit: "contain" }} />
              ) : (
                <i className={menuItem.icon}></i>
              )}
              {!showsiderbar && <span>{menuItem.label}</span>}
            </Link>
          )}
        </li>

        {menuItem.hasChildren && menuItem.expanded && (
          renderMenuItem(menuItem.children, level + 1, true)
        )}
      </React.Fragment>
    ));
  };


  return (
    <div
      id="dc-sidebarwrapper"
      className="dc-sidebarwrapper dc-fixednav"
      style={{ width: isMobile ? "250px" : showsiderbar ? "50px" : "250px", overflow: "scroll" }}
    >
      {!isMobile && (
        <div>
          <div
            id="dc-btnmenutoggle"
            className="dc-btnmenutoggle"
            style={{ display: "block", marginLeft: showsiderbar ? "0px" : "200px", marginTop: "40px" }}
            onClick={handleClick}
          >
            <i className={`ti-arrow-${showsiderbar ? "right" : "left"}`}></i>
          </div>
        </div>
      )}

      <div id="dc-verticalscrollbar" className="dc-verticalscrollbar mCustomScrollbar">
        <div className="dc-companysdetails dc-usersidebar">
          <figure className="dc-companysimg">
            {userdata.profile_banner_url ? (
              <ImageShow
                image={userdata.profile_banner_url}
                height={0}
                width={0}
                url={userdata.profile_banner_url}
                style={{ objectFit: "fill", objectPosition: "center" }}
              />
            ) : (
              <img src={bannerimglocal} alt="banner" />
            )}
          </figure>

          {!showsiderbar && (
            <div className="dc-companysinfo">
              <figure>
                {userdata.profile_photo_url ? (
                  <ImageShow url={userdata.profile_photo_url} width={100} height={100} />
                ) : (
                  <img src={userimglocal} alt="profile" />
                )}
              </figure>
              <div className="dc-title">
                <h2>
                  {["admin", "hospitals", "pharmacy", "hospital-admin", "pharmacy-admin"].includes(userType) ? (
                    <a target="_blank" rel="noreferrer" href={`/doctor/${formatUrlString(displayName)}/${encryptId(userdata.id)}`}>
                      {displayName}
                    </a>
                  ) : (
                    <span>{displayName}</span>
                  )}
                </h2>
              </div>
            </div>
          )}
        </div>

        <nav id="dc-navdashboard" className="dc-navdashboard">
          <ul className="dashboard-menu-left">
            {renderMenuItem(menuList)}
          </ul>
        </nav>

        <div className={showsiderbar ? "dc-navdashboard-footer-mobile" : "dc-navdashboard-footer"}>
          <span className="dc-navdashboard-footer-text">
            Copyrights © 2019 by OneKlicks All Rights Reserved
          </span>
        </div>
      </div>
    </div>
  );
};

export default SiderBar;
